import styled from 'styled-components';
import {
  FilterType,
  ItemStatusData,
  RightStatusData,
  LesseeStatusData,
  FormalAuctionData,
  PtypeItemStatusData,
  PTypeRightStatusData,
  PTypeLesseeStatusData,
} from '../FilterData';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
  SelectedChip,
  SelectedChipBox,
} from './OptionModal.styles';

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

const TabData = ['물건현황', '권리', '임차인', '형식적경매'];

const viewOption = [
  { value: 'a', label: '모두 해당' },
  { value: 'o', label: '1개 이상 포함' },
];

function SpecialConditionOption({ onClose, filters, setFilters }: Props) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('물건현황');
  const [selectedItems, setSelectedItems] = useState<string[]>(
    filters.specialItemCondition,
  );
  const [selectedViewOption, setSelectedViewOption] = useState('a');

  const toggleItem = (value: string) => {
    setSelectedItems((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const renderOptionList = () => {
    switch (selectedTab) {
      case '물건현황':
        const itemData =
          filters.type === 'a' ? ItemStatusData : PtypeItemStatusData;
        const allSelectedManagement = itemData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedManagement) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) => !itemData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([...prev, ...itemData.map((d) => d.name)]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedManagement ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                물건현황 전체
              </Option>

              {itemData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '권리':
        const rightStatus =
          filters.type === 'a' ? RightStatusData : PTypeRightStatusData;
        const allSelectedExtraction = rightStatus.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedExtraction) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !rightStatus.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([...prev, ...rightStatus.map((d) => d.name)]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedExtraction ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                권리 전체
              </Option>

              {rightStatus.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '임차인':
        const lesseeStatus =
          filters.type === 'a' ? LesseeStatusData : PTypeLesseeStatusData;
        const allSelectedDistrict = lesseeStatus.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedDistrict) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !lesseeStatus.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([...prev, ...lesseeStatus.map((d) => d.name)]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedDistrict ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                임차인 전체
              </Option>

              {lesseeStatus.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
      case '형식적경매':
        if (filters.type === 'p') {
          return;
        }
        const allSelectedArea = FormalAuctionData.every((item) =>
          selectedItems.includes(item.name),
        );
        return (
          <>
            <OptionList>
              <Option
                onClick={() => {
                  if (allSelectedArea) {
                    setSelectedItems((prev) =>
                      prev.filter(
                        (item) =>
                          !FormalAuctionData.map((d) => d.name).includes(item),
                      ),
                    );
                  } else {
                    setSelectedItems((prev) =>
                      Array.from(
                        new Set([
                          ...prev,
                          ...FormalAuctionData.map((d) => d.name),
                        ]),
                      ),
                    );
                  }
                }}
              >
                <img
                  src={`/assets/images/check/${
                    allSelectedArea ? 'check-blue-on' : 'check-blue-off'
                  }.svg`}
                  alt=""
                />
                형식적경매 전체
              </Option>

              {FormalAuctionData.map(({ name }) => (
                <Option key={name} onClick={() => toggleItem(name)}>
                  <img
                    src={`/assets/images/check/${
                      selectedItems.includes(name)
                        ? 'check-blue-on'
                        : 'check-blue-off'
                    }.svg`}
                    alt=""
                  />
                  {name}
                </Option>
              ))}
            </OptionList>
          </>
        );
    }
  };

  const handleReset = () => {
    setSelectedItems([]);
  };

  const handleSubmit = () => {
    setFilters({
      ...filters,
      specialConditionViewOption: selectedViewOption,
      specialItemCondition: selectedItems,
    });
    onClose();
  };

  return (
    <Container>
      <Header>
        <Title>
          <img
            src="/assets/images/arrow/back-arrow-left-gray.svg"
            alt=""
            onClick={() => navigate(-1)}
            width={24}
            height={24}
          />
          특수조건
        </Title>
        <img
          src="/assets/images/close/close-dark-gray.svg"
          alt=""
          onClick={onClose}
        />
      </Header>
      <ViewOptionBox>
        보기옵션
        <ViewOptionInputBox>
          {viewOption.map((option) => (
            <RadioInputWrapper>
              <input
                type="radio"
                id={option.value}
                name="specialCondition"
                value={option.value}
                checked={selectedViewOption === option.value}
                onChange={() => setSelectedViewOption(option.value)}
              />
              <label htmlFor={option.value}>{option.label}</label>
            </RadioInputWrapper>
          ))}
        </ViewOptionInputBox>
        <span>
          {selectedViewOption === 'a'
            ? '선택한 조건이 모두 해당하는 물건을 검색합니다.'
            : '선택한 조건을 1개 이상 포함하는 물건을 검색합니다.'}
        </span>
      </ViewOptionBox>
      <TabList>
        {TabData.map((data) => (
          <Tab
            active={selectedTab === data}
            onClick={() => setSelectedTab(data)}
          >
            {data}
          </Tab>
        ))}
      </TabList>
      <OptionWrapper>{renderOptionList()}</OptionWrapper>
      <Bottom>
        <SelectedChipBox>
          {selectedItems.map((item) => (
            <SelectedChip>
              {item}
              <img
                src="/assets/images/close/close-gray.svg"
                alt=""
                onClick={() => toggleItem(item)}
              />
            </SelectedChip>
          ))}
        </SelectedChipBox>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Container>
  );
}

export default SpecialConditionOption;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
  padding: 12px 16px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const TabList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid #e1e2e4;
`;

const Tab = styled.div<{ active?: boolean }>`
  flex: 1;
  padding: 14px 16px;
  font-weight: ${(props) => (props.active ? 700 : 500)};
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  white-space: nowrap;
  text-align: center;

  color: ${(props) => (props.active ? '#000' : '#989BA2')};
  border-bottom: 2px solid ${(props) => (props.active ? '#000' : 'transparent')};
  cursor: pointer;
`;

const OptionWrapper = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  gap: 8px;
  padding: 24px 16px;
`;

const OptionList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 8px;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding: 8px 0;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const ViewOptionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;

  span {
    color: #616161;
    font-weight: 400;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: -2%;
  }
`;

const ViewOptionInputBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

const RadioInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  label {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #616161;
  }
`;
